export const REALIZED_PNL = {
  prefix: "$",
  value: 184553.83,
  suffix: "",
  change: 0,
  changeSuffix: "",
  decimals: 0,
};
